import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-role-dialog',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [MatDialogModule, TranslateModule],
  template: `
    <h2 mat-dialog-title>{{ 'ROLES_DELETE_TITLE' | translate }}</h2>
    <mat-dialog-content>
      <p>{{ 'ROLES_DELETE_CONFIRM' | translate : { name: data.name } }}</p>
      @if (data.assignedStaffCount > 0) {
        <p class="text-danger mb-0" data-testid="delete-role-holders-warning">
          <span class="fa-light fa-fw fa-triangle-exclamation"></span>
          {{ 'ROLES_DELETE_HOLDERS' | translate : { count: data.assignedStaffCount } }}
        </p>
      }
    </mat-dialog-content>
    <mat-dialog-actions class="ml-3 mb-3">
      <button class="btn btn-outline-danger mr-2" (click)="confirm()" data-testid="delete-role-confirm">
        <span class="fa-light fa-fw fa-trash-alt"></span> {{ 'DELETE' | translate }}
      </button>
      <button class="btn btn-outline-dark" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </mat-dialog-actions>
  `
})
export class DeleteRoleDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DeleteRoleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { name: string; assignedStaffCount: number }
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
